import { themes } from '@/constants/colors_v2';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const initialState: any = {
  currentTheme: themes.light
};

export const currentThemeSlice = createSlice({
  name: 'currentTheme',
  initialState,
  reducers: {
    setCurrentTheme: (state, action: PayloadAction<string>) => {
      state.currentTheme = action.payload;
    }
  }
});

export const { setCurrentTheme } = currentThemeSlice.actions;

export default currentThemeSlice.reducer;
